import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantShopPayRentalPage } from './merchant-shop-pay-rental';

@NgModule({
  declarations: [
    MerchantShopPayRentalPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantShopPayRentalPage),
    TranslateModule.forChild()
  ],
})
export class MerchantShopPayRentalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-pay-rental/merchant-shop-pay-rental.module.ts